import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UncontrolledTooltip } from 'reactstrap';
import operEsapService from '../../../../../services/operEsapService';
import { Esap } from '../../../../../services/types/Flow';
import { Button, LinkButton, SpinnerArea } from '../../../../../shared/components';
import { dateTimeFormat, tooltipPreventOverflowModifiers } from '../../../../../shared/misc/utils';
import Context from '../../../../App/MainProvider/context';

interface Props {
  data: Esap;
  flowType: string;
}

const CurrentEsap: React.FC<Props> = ({ data, flowType }) => {
  const { t } = useTranslation();
  const { service } = useContext(Context);

  const [loading, setLoading] = useState(false);

  const downloadDoc = (versionId: number) => {
    service(() => operEsapService.downloadDocVersion(versionId), {
      loader: setLoading,
    });
  };

  return (
    <tr>
      <td>
        <LinkButton
          onClick={() => window.open(data.wordOnlineLink)}
          icon="file-word"
          text={`ESAP v.${data.version}`}
        />
      </td>
      {/* eslint-disable jsx-a11y/control-has-associated-label -- celdas espaciadoras, sin contenido */}
      {flowType === 'SR_ESPF' && (
        <>
          <td />
          <td />
          <td />
        </>
      )}
      <td />
      <td>{dateTimeFormat(data.createdOn)}</td>
      <td>{data.createdBy}</td>
      <td>{t(`languageCodes.${data.language}`)}</td>
      <td />
      {/* eslint-enable jsx-a11y/control-has-associated-label */}
      <td>
        <div className="d-flex">
          <SpinnerArea loading={loading}>
            <Button
              htmlId="esapDownload"
              className="btn-tertiary no-padding"
              icon="file-download"
              text=""
              onClick={() => downloadDoc(data.id)}
            />

            <UncontrolledTooltip
              className="tooltip-impact"
              placement="bottom"
              target="esapDownload"
              modifiers={tooltipPreventOverflowModifiers}
            >
              {t('downloadEsap')}
            </UncontrolledTooltip>
          </SpinnerArea>
        </div>
      </td>
    </tr>
  );
};

export default CurrentEsap;
